import type { AboutPage, AboutPageQuery } from '@edwin-group/people-graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_ABOUT_PAGE } from '@edwin-group/people-graphql';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<AboutPageQuery>({
      query: QUERY_ABOUT_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.aboutPage?.data?.attributes as AboutPage,
    error,
  };
};
